module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topclass"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.length > 0),
      expression: "data.length > 0"
    }]
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', [_vm._v(_vm._s(key.value))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(entry) {
    return _c('tr', {
      on: {
        "click": function($event) {
          return _vm.clicked(entry)
        }
      }
    }, _vm._l((_vm.columns), function(key) {
      return _c('td', [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!key.button),
          expression: "!key.button"
        }]
      }, [_vm._v(_vm._s(entry[key.key]) + _vm._s(key.append))]), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (key.button),
          expression: "key.button"
        }]
      }, [_c('button', {
        staticClass: "btn btn-danger RightButton",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.BClicked(entry)
          }
        }
      }, [_vm._v("X")])])])
    }), 0)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-495312d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/grid.vue
// module id = 43
// module chunks = 3